import React from 'react';
import { Button as RoccoButton } from '@rocco/components/button';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import type { FilterConfigModalItemDefault } from '@rocco/ui/filter-sort/types/filter-config-modal';
import type { MultipleValuesFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/multiple-values-filter-state';
import type { FilterModalElementProps } from '@rocco/ui/filter-sort/components/filters-modal/FiltersModalElement';

export const FiltersModalMultipleValuesButtons = (
    props: FilterModalElementProps<
        FilterConfigModalItemDefault,
        MultipleValuesFilterState
    >,
) => {
    const { filterState, onFilterStateUpdate } = props;
    const {
        searchFilters: { handleToggleMultipleValues },
    } = useFiltersContext();

    return (
        <div className="flex flex-wrap gap-2 pt-2">
            {filterState.items.map((item, index) => (
                <RoccoButton
                    key={index}
                    color={item.checked ? 'primary' : 'outline'}
                    shape="squareRounded"
                    inverted={item.checked}
                    onClick={() => {
                        if (handleToggleMultipleValues) {
                            onFilterStateUpdate(
                                handleToggleMultipleValues(
                                    filterState,
                                    item,
                                    !item.checked,
                                ),
                            );
                        }
                    }}
                >
                    {item.label}
                </RoccoButton>
            ))}
        </div>
    );
};
